export const FETCH_TAGS_START = 'FETCH_TAGS_START';
export const FETCH_TAGS_SUCCESS = 'FETCH_TAGS_SUCCESS';
export const FETCH_TAGS_FAIL = 'FETCH_TAGS_FAIL';

export type TagActionTypes = typeof FETCH_TAGS_START | typeof FETCH_TAGS_SUCCESS | typeof FETCH_TAGS_FAIL;
